import React from 'react'

import { Box, Tooltip } from '@chakra-ui/react'
import { camelToWords } from '@/utils/stringHelper'

const normalizeTooltipText = (value) => {
  if (value === null || value === undefined) {
    return ''
  }

  if (React.isValidElement(value)) {
    return value
  }

  if (Array.isArray(value)) {
    return value.map((item) => normalizeTooltipText(item)).join(', ')
  }

  if (typeof value === 'object') {
    return value.description || value.productName || value.label || value.name || value._id || ''
  }

  return value
}

export const TooltipCellRenderer = ({ cell: { value } }) => <TooltipCell text={value} />
export const TooltipCellRenderer2 = ({ cell: { getValue } }) => <TooltipCell text={getValue()} />
export const NormalTextCellRenderer = ({ cell: { getValue } }) => <TooltipCell text={camelToWords(getValue())} />

export const TooltipCell = ({ text, tooltip = text, color = 'black' }) => (
  <Tooltip label={normalizeTooltipText(tooltip)} closeOnScroll>
    <Box color={color}>{normalizeTooltipText(text)}</Box>
  </Tooltip>
)
